import { giveawayModuleIds, } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const redemeedRewardsModalModule = {
    [giveawayModuleIds.REDEEMED_REWARDS_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
